import { AxiosError, type  AxiosResponse } from 'axios';
import axios from 'axios';

const functionUrl = 'https://kd-stylo-fabric-wkpldwgvfx.cn-hangzhou.fcapp.run';

// ======================  定义类型（类型安全） ======================
/** 传入云函数的参数类型 */
interface FabricRequestParams {
  fabric?: string;
  style?: string;
}

/** 云函数返回的响应类型 */
interface FabricResponse {
  styles: string[];
  fabrics: string[];
}


// ======================  配置 Axios 实例 ======================
const fcAxios = axios.create({
  // 云函数 HTTP 触发器 URL
  baseURL: functionUrl, 
  // 超时时间（云函数冷启动可能稍久，建议设 10s）
  timeout: 10000, 
  headers: {
    'Content-Type': 'application/json',
  },
});

// ======================  封装云函数调用方法 ======================
/**
 * 调用获取 Fabric 样式的云函数
 * @param params 传入的 fabric 参数
 * @returns 云函数返回的 styles 数组
 */
export const getFabricStyles = async (
  params: FabricRequestParams
): Promise<FabricResponse> => {
  try {
    // 发送 POST 请求（云函数建议用 POST 传递 JSON 数据）
    const response: AxiosResponse<FabricResponse>  = await fcAxios.post(
      functionUrl, // 触发器路径（若配置了路径需填写）
      params // 传入的 JSON 参数（{ fabric: "1YX6agSEY8w" }）
    );
    return response.data;
  } catch (error) {
    // 抛出错误供业务层捕获
    const err = error as AxiosError;
    throw new Error(err.message || '调用云函数失败');
  }
};